module.exports = __webpack_public_path__ + "img/babel.cffce49f.png";